import { Container, Box, Paper } from '@mui/material';
// routes
import { paths } from 'src/routes/paths';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
// components
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from 'src/api/axiosInstance';
import { enqueueSnackbar } from 'notistack';
import { useSettingsContext } from 'src/components/settings';
// import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import CandidateNewEditForm from '../candidateReplicaForm';
import CandidateEditView from './candidate-replica-detail-view';

export default function CandidateReplicaCreateView() {
  const settings = useSettingsContext();
  const { id } = useParams(); // Get the 'id' from the URL
  const [candidateData, setCandidateData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      // If id exists, fetch candidate data from the API
      axiosInstance
        .get(`/rest/candidate/external/singleCandDetails/${id}`)
        .then((response) => {
          setCandidateData(response.data); // Set the candidate data to prefill the form
        })
        .catch((error) => {
          enqueueSnackbar('Error fetching candidate details', { variant: 'error' });
        });
    }
  }, [id]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      {id ? (
        // If there's an id, render the CandidateEditView with the fetched candidate data
        <CandidateEditView currentCand={candidateData} />
      ) : (
        // If no id exists, render the CandidateNewEditForm
        <CandidateNewEditForm />
      )}
    </Container>
  );
}
